<template>
    <div class="page gm-bg">
      <div class="game-html">
          <div class="txtcenter" style="font-size:20px;font-weight: 700;">ဂိမ်းများ</div>
          <div class="game-content">
            <div class="game-li" v-for="(item,index) in list" @click="goGame(item)">
              <div class="gm-t">{{item.title}}</div>
              <img class="gm-img" :src="item.icon_image" />
              <div class="play">
                <img src="../assets/play.png" />
              </div>
            </div>
          </div>
          <div class="more txtcenter">
            <img @click="getMore" src="../assets/more.png" />
          </div>
          <!-- ထပ်ကြည့်မယ် -->
        </div>
        <div class="txtcenter" >
          <img class="gm-b" src="../assets/game-img1.png" />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Setting',
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],
            showSharePop: false,
            shareUrl: 'http://qs.wobangta.com/#/share',
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id,
            isShow:true,
            page:1,
            page_size:9
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){
      this.getHome();
    },
    methods: {
        goto(page){
            this.$router.push(page);
        },
        goGame(item){
          this.$router.push({path:'/game',query:{game_id:item.game_id}});
        },
        getHome(item){
          let that = this
          Utils.$ajax({
              url: '/game/list&page_id='+this.page+'&page_size='+this.page_size
          }).done(res=>{
            console.log(res)
              if(res.code != 0){
                  this.$messagebox_lang(res.msg).then();
                  return;
              }else{
                //this.list = res.data.list
                if(res.data.list.length>0){
                  if(that.page>1){
                    that.list = that.list.concat(res.data.list)
                  }else{
                    that.list = res.data.list
                  }
                }else{
                	that.isShow = false;
                }
              }
          })
        },
        getMore(){
        	let that = this;
        	if(that.isShow){
        		that.page++;
        		that.getHome();
        	}else{
            this.$messagebox_lang('noMore').then(action=>{
            });
        	}
        },
        unsub(){
            let url = 'http://chmemm.com/gw/checking.php?action=UNREG&msisdn=';
            //let msg = 'အေကာင္းဆုံးဆုေတြ ရရွိဖို႔အတြက္ အဖြဲ႕ဝင္အျဖစ္မွ ႏႈတ္ထြက္မသြားေစခ်င္ပါဘူး';
            let msg = 'အဖွဲ့ဝင်အဖြစ်မှ နှုတ်ထွက်ရန် သေချာပြီလား?';
            let msisdn = localStorage.localMisisdn;
            this.$dialog.confirm({
                message: msg,
                confirmButtonText: 'yes',
                cancelButtonText: 'no'
            }).then(action=>{
                //alert(action);
                if(action === 'confirm'){
                    localStorage.clear();
                    window.location = url + msisdn;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .game-html{margin-top: 20px;}
  .game-content{display: flex;flex-wrap:wrap}
  .game-li{width:30.33%;margin:1% 1.5% 10px;background: #476bf7;text-align: center;border-radius: 10px;padding: 10px 10px 20px;position: relative;}
  .gm-img{width:100%;margin-top: 10px;border-radius: rem(15);width:rem(155);height: rem(155);}
  .gm-t{color:#fff;font-size: 11px;letter-spacing: -0.5px;}
  .play img{
  width: rem(127);
  height:rem(49);
  }
  .play{position: absolute;bottom:rem(-25);left:50%;margin-left: rem(-64);}
  .more{margin-top: 10px;}
  .more img{
  width: rem(214);
  height:rem(63);}
  .gm-b{
  width: rem(669);
  height:rem(232);}
  .gm-bg{background:url(../assets/game-bg.png) no-repeat 0 bottom;background-size: rem(750) rem(825);}
    .menu-wrap{
        display: flex;
        width: rem(728);
        height: rem(538);
        margin:rem(240) auto 0;
        background: url('~@/assets/menu-1.png') center center/contain no-repeat;
        justify-content: space-between;
        flex-wrap: wrap;
        .menu-item{
            width: rem(363);
            height: rem(228);
            margin-bottom: rem(70);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/comingSoon.vue